import {z} from "zod/v4-mini"
import * as legacyZod from "zod"

export const scalarMathNodeOperation = z.enum([
    "ADD",
    "SUBTRACT",
    "MULTIPLY",
    "DIVIDE",
    "MULTIPLY_ADD",
    "POWER",
    "LOGARITHM",
    "SQRT",
    "INVERSE_SQRT",
    "ABSOLUTE",
    "EXPONENT",
    "MINIMUM",
    "MAXIMUM",
    "LESS_THAN",
    "GREATER_THAN",
    "SIGN",
    "COMPARE",
    "SMOOTH_MIN",
    "SMOOTH_MAX",
    "ROUND",
    "FLOOR",
    "CEIL",
    "TRUNC",
    "FRACT",
    "MODULO",
    "FLOORED_MODULO",
    "WRAP",
    "SNAP",
    "PINGPONG",
    "SINE",
    "COSINE",
    "TANGENT",
    "ARCSINE",
    "ARCCOSINE",
    "ARCTANGENT",
    "ARCTAN2",
    "SINH",
    "COSH",
    "TANH",
    "RADIANS",
    "DEGREES",
])
export type ScalarMathNodeOperation = z.infer<typeof scalarMathNodeOperation>

export const legacyScalarMathNodeOperationSchema = legacyZod.enum([
    "ADD",
    "SUBTRACT",
    "MULTIPLY",
    "DIVIDE",
    "MULTIPLY_ADD",
    "POWER",
    "LOGARITHM",
    "SQRT",
    "INVERSE_SQRT",
    "ABSOLUTE",
    "EXPONENT",
    "MINIMUM",
    "MAXIMUM",
    "LESS_THAN",
    "GREATER_THAN",
    "SIGN",
    "COMPARE",
    "SMOOTH_MIN",
    "SMOOTH_MAX",
    "ROUND",
    "FLOOR",
    "CEIL",
    "TRUNC",
    "FRACT",
    "MODULO",
    "FLOORED_MODULO",
    "WRAP",
    "SNAP",
    "PINGPONG",
    "SINE",
    "COSINE",
    "TANGENT",
    "ARCSINE",
    "ARCCOSINE",
    "ARCTANGENT",
    "ARCTAN2",
    "SINH",
    "COSH",
    "TANH",
    "RADIANS",
    "DEGREES",
])
